import React from "react";
import { isProductionEnvironment } from "utils/network";

export function ProjectMetadataDisplay(): JSX.Element {
  if (isProductionEnvironment()) return <></>;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        right: 0,
      }}
    >
      Ambiente: {process.env.NODE_ENV}
    </div>
  );
}
